export default "__VITE_ASSET__Bg2605KQ__"